import ResponseMessage from '@/components/Error/ResponseMessage';
import { Spacer, VStack } from '@/components/Layout';
import { Text } from '@/components/Typography/Text';
import { defaultNS, useTranslation } from '@/lib/i18n';

type FormItem = {
  fieldTitle?: string;
  description?: string;
  fieldInput: React.ReactNode;
  optional?: boolean;
  errorMessage?: string;
  className?: string;
};

export const FormItem = ({
  fieldTitle,
  description,
  fieldInput,
  optional = false,
  errorMessage,
  className,
}: FormItem) => {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: 'component.input',
  });

  return (
    <VStack className={`min-w-48 ${className}`}>
      {fieldTitle && (
        <>
          <Text
            variant="labelSmall"
            className="py-1 text-neutral-muted-on-fill"
          >
            {fieldTitle} {optional && t('optional')}
          </Text>
          <Spacer />
        </>
      )}
      {description && (
        <Text
          className="py-1 text-neutral-muted-on-fill"
          variant="labelSmallReg"
        >
          {description}
        </Text>
      )}
      {fieldInput}
      <ResponseMessage>{errorMessage}</ResponseMessage>
    </VStack>
  );
};
